import setPromiseState from '../../utils/promiseState';
import actionTypes from './ActioTypes';
import InitState from './InitState';

export default (state = InitState, actions) => {
  switch (actions.type) {

    case actionTypes.GET_TOUR_BY_ID.pending:
      return {...state, promise: {...state.promise, getTour: {...setPromiseState(true, false, false)}}};
    case actionTypes.GET_TOUR_BY_ID.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, getTour: {...setPromiseState(false, false, true)}}};
    case actionTypes.GET_TOUR_BY_ID.fulfilled: {
      return {...state, tour: actions.data || [], promise: {...state.promise, getTour: {...setPromiseState(false, true, false)}}};
    }

    case actionTypes.TOUR_PAGE_UN_MOUNTED:
      return {...InitState};

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/Reducer.js